import styled from "@emotion/styled";
import { Chip, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import ImageList from "../ImageList";

const ImageTile = styled.div`
  display: block;
  max-width: 300px;
`;

const ImageTitle = styled.h2`
  text-align: left;
  margin: 5pt 0pt;
`;

const ImageDescription = styled.p`
  margin: 5pt 0pt;
`;

const NavLinkItem = styled(NavLink)`
  text-decoration: none;
  color: #333;
`;

const NotAvailable = styled.span`
  font-size: 10pt;
  color: #666;
  border: 1px solid #ccc;
  padding: 5px 10px;
  border-radius: 5px;
  margin-top: 5px;
  display: inline-block;
  clear: left;
`;

const Gallery = () => {
  return (
    <Grid
      container
      columnGap={10}
      rowGap={10}
      width={"100%"}
      justifyContent={"center"}
      columns={4}
    >
      {ImageList.map((element, index) => {
        return (
          <Grid item key={`${element.id}`}>
            <motion.div
              key={element.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 + (0.3 * (Math.min(index, 4))) }}
            >
              <ImageTile id={element.id}>
                <NavLinkItem to={`/originals/${element.id}`}>
                  <img
                    src={`/images/originals/${element.id}/300.jpeg`}
                    width={"100%"}
                    alt={element.title}
                  />
                  <ImageTitle>{element.title}</ImageTitle>
                  {element.original.onCharitySale &&
                  <Chip label="60% off for charity sale" sx={{ 
                    fontWeight: 600,
                    backgroundColor: '#ba494e',
                    color: '#fff',
                  }} />}
                  <ImageDescription>{element.shortText}</ImageDescription>
                  {!element.original.etsyUrl && <NotAvailable>Sorry, not available for purchase</NotAvailable>}
                </NavLinkItem>
              </ImageTile>
            </motion.div>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Gallery;
